import { URL } from '@core/constants/url.constant';
import { ApiValidate } from '@core/decorators/ApiValidate.decorator';
import { apiService } from '@core/services/Api.service';
import { abcloudzLoginSchema } from '../schemas/login.schema';
import type { TLogin, TAbcloudzLoginCredentials } from '../models/login.model';

class LoginService {
  @ApiValidate(abcloudzLoginSchema)
  public abcloudzLogin(dto: TAbcloudzLoginCredentials, silent?: boolean) {
    return apiService.post<TLogin>({
      url: URL.abcloudzLogin,
      dto,
      config: { silent }
    });
  }
}

const loginService = new LoginService();

export { loginService };
